import * as React from 'react';
import Page from '../containers/Page';

export default () => (
  <Page title="Trash">
      trash page
    </Page>
)